"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTripEntity = exports.DayTripItineraryItemPassByLocation = exports.DayTripItineraryItemPhotoLocation = exports.DayTripItineraryItemLocation = exports.DayTripItineraryItemEdgeLocation = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
class DayTripImage {
    url;
    isThumbnail;
}
class DayTripItineraryItemImage {
    url;
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripItineraryItemImage.prototype, "url", void 0);
let WorkingHours = class WorkingHours {
    day;
    openFromIsoTime;
    openUntilIsoTime;
};
__decorate([
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], WorkingHours.prototype, "day", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], WorkingHours.prototype, "openFromIsoTime", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Object)
], WorkingHours.prototype, "openUntilIsoTime", void 0);
WorkingHours = __decorate([
    (0, class_transformer_1.Expose)()
], WorkingHours);
class BaseDayTripItineraryItem {
    order;
    locationId;
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], BaseDayTripItineraryItem.prototype, "order", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], BaseDayTripItineraryItem.prototype, "locationId", void 0);
const DayTripItineraryItemTypes = [
    legacy_enums_1.DayTripItineraryItemLocationType.edgeLocation,
    legacy_enums_1.DayTripItineraryItemLocationType.location,
    legacy_enums_1.DayTripItineraryItemLocationType.photoLocation,
    legacy_enums_1.DayTripItineraryItemLocationType.passByLocation,
];
class DayTripItineraryItemEdgeLocation extends BaseDayTripItineraryItem {
    type;
}
exports.DayTripItineraryItemEdgeLocation = DayTripItineraryItemEdgeLocation;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripItineraryItemLocationType),
    (0, class_validator_1.IsIn)(DayTripItineraryItemTypes),
    __metadata("design:type", String)
], DayTripItineraryItemEdgeLocation.prototype, "type", void 0);
class BaseSightseeingDayTripItineraryItem extends BaseDayTripItineraryItem {
    description;
    images;
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], BaseSightseeingDayTripItineraryItem.prototype, "description", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)({ each: true, always: true }),
    __metadata("design:type", Array)
], BaseSightseeingDayTripItineraryItem.prototype, "images", void 0);
class DayTripItineraryItemLocation extends BaseSightseeingDayTripItineraryItem {
    type;
    durationMinutes;
    admission = legacy_enums_1.DayTripItineraryItemAdmission.notIncluded;
    workingHours;
}
exports.DayTripItineraryItemLocation = DayTripItineraryItemLocation;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripItineraryItemLocationType),
    (0, class_validator_1.IsIn)(DayTripItineraryItemTypes),
    __metadata("design:type", String)
], DayTripItineraryItemLocation.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(1),
    __metadata("design:type", Number)
], DayTripItineraryItemLocation.prototype, "durationMinutes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripItineraryItemAdmission),
    __metadata("design:type", String)
], DayTripItineraryItemLocation.prototype, "admission", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)({ each: true }),
    __metadata("design:type", Array)
], DayTripItineraryItemLocation.prototype, "workingHours", void 0);
class DayTripItineraryItemPhotoLocation extends BaseSightseeingDayTripItineraryItem {
    type;
    durationMinutes;
    admission = legacy_enums_1.DayTripItineraryItemAdmission.notIncluded;
}
exports.DayTripItineraryItemPhotoLocation = DayTripItineraryItemPhotoLocation;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripItineraryItemLocationType),
    (0, class_validator_1.IsIn)(DayTripItineraryItemTypes),
    __metadata("design:type", String)
], DayTripItineraryItemPhotoLocation.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DayTripItineraryItemPhotoLocation.prototype, "durationMinutes", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripItineraryItemAdmission),
    __metadata("design:type", String)
], DayTripItineraryItemPhotoLocation.prototype, "admission", void 0);
class DayTripItineraryItemPassByLocation extends BaseSightseeingDayTripItineraryItem {
    type;
}
exports.DayTripItineraryItemPassByLocation = DayTripItineraryItemPassByLocation;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripItineraryItemLocationType),
    (0, class_validator_1.IsIn)(DayTripItineraryItemTypes),
    __metadata("design:type", String)
], DayTripItineraryItemPassByLocation.prototype, "type", void 0);
class DayTripFAQ {
    questionMarkdown;
    answerMarkdown;
}
__decorate([
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], DayTripFAQ.prototype, "questionMarkdown", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], DayTripFAQ.prototype, "answerMarkdown", void 0);
let DayTripEntity = class DayTripEntity {
    _id = (0, uuid_1.v4)();
    isActive = false;
    name;
    description;
    sightseeingDescription;
    beforeYouGoDescriptionMarkdown;
    totalPrice;
    fee;
    minPassengerCount;
    pricingCurrency;
    images;
    itineraryItems;
    /**
     * Represents the whole package without the destination location
     * */
    packageSlug;
    stopsUrlSlug;
    totalTripTimeMinutes;
    variation = legacy_enums_1.DayTripVariation.BASIC_DAY_TRIP;
    faqs = [];
    originLocationId;
    originCountryId;
    originCountryContinent;
    bookingCount = 0;
};
exports.DayTripEntity = DayTripEntity;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)("4"),
    __metadata("design:type", String)
], DayTripEntity.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Boolean)
], DayTripEntity.prototype, "isActive", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "sightseeingDescription", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "beforeYouGoDescriptionMarkdown", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DayTripEntity.prototype, "totalPrice", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DayTripEntity.prototype, "fee", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DayTripEntity.prototype, "minPassengerCount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    __metadata("design:type", Number)
], DayTripEntity.prototype, "pricingCurrency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)({ each: true, always: true }),
    __metadata("design:type", Array)
], DayTripEntity.prototype, "images", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)({ each: true, always: true }),
    __metadata("design:type", Array)
], DayTripEntity.prototype, "itineraryItems", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)()
    /**
     * Represents the whole package without the destination location
     * */
    ,
    __metadata("design:type", String)
], DayTripEntity.prototype, "packageSlug", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "stopsUrlSlug", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DayTripEntity.prototype, "totalTripTimeMinutes", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.DayTripVariation),
    __metadata("design:type", String)
], DayTripEntity.prototype, "variation", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    __metadata("design:type", Array)
], DayTripEntity.prototype, "faqs", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "originLocationId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "originCountryId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DayTripEntity.prototype, "originCountryContinent", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], DayTripEntity.prototype, "bookingCount", void 0);
exports.DayTripEntity = DayTripEntity = __decorate([
    (0, typeorm_1.Entity)("dayTrips")
], DayTripEntity);
//# sourceMappingURL=DayTripEntity.js.map